module.exports = __webpack_public_path__ + "pinkfong-symbol-ctlg.png?1c845c21dd28b1e0f12b90f5c47510ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinkfong-symbol-ctlg.png
// module id = 461
// module chunks = 0